@if (!isExpanded) {
<div
  class="container"
  [style]="{
    border: '2px solid #e1e8fb',
    'border-radius': '25px',
    padding: '5px',
    marginTop: '5px',
  }"
  [ngClass]="{ 'program-selected': isProgramSelected() }"
>
  <div
    class="row h-4rem align-items-center justify-content-between"
    [class]="isSelecting ? 'cursor-pointer' : ''"
    (click)="isSelecting ? toggleCollapsed() : null"
  >
    <div class="col-3 d-flex align-items-center">
      <button
        type="button"
        class="btn btn-primary position-relative program-name"
        (click)="!isSelecting ? toggleCollapsed() : null"
        [id]="'toggleCollapseButton-' + program?.ProgramName"
      >
        {{ program?.ProgramName }}
        <i
          class="pi pi-circle-fill ms-2"
          style="
            font-size: 1rem;
            color: #9382ad;
            border: 1px solid white;
            border-radius: 50%;
          "
          *ngIf="programAlerts().length > 0"
        ></i>
      </button>
    </div>

    @if (program?.IsDeleted) {
    <div class="col-1 d-flex">
      <p-tag id="deleted-tag" severity="danger" value="Deleted" class="ms-2" />
      <!-- <div class="m-0 p-0 ml-1" role="button" (click)="restoreProgram()">
        <p-tag id="restore-tag" severity="info" value="Restore" class="ms-2" />
      </div> -->
    </div>

    } @if (program?.IsArchived) {
    <div class="col-1">
      <p-tag
        id="archived-tag"
        severity="warning"
        value="Archived"
        class="ms-2"
      />
    </div>
    }

    <div class="col-3 col-md-3 mx-3 mt-2 mt-md-0">
      <span class="fs-8 fw-bolder" style="color: #719eb6">
        Included Playlists:
      </span>
      <span class="fs-8" style="color: #719eb6">
        {{ program!.ID != null ? playlistsToDisplay(program!.ID) : "None" }}
      </span>
    </div>
    <div class="col-3 col-md-3 mx-3 mt-2 mt-md-0">
      <span class="fs-8 fw-bolder" style="color: #719eb6"> Skill Areas: </span>
      <span class="fs-8" style="color: #719eb6">
        {{ skillAreasToDisplay }}
      </span>
    </div>

    <div class="col-1">
      <i
        class="pi pi-circle-fill me-2"
        style="
          font-size: 1rem;
          border: 2px solid #e1e8fb;
          border-radius: 50%;
          cursor: pointer;
        "
        [style.color]="getCircleColor()"
        [style.border-radius]="'50%'"
        [title]="getCircleTooltip()"
      ></i>
      <i
        class="pi pi-arrow-down pointer"
        style="font-size: 1rem; color: #719eb6"
        (click)="toggleCollapsed()"
      ></i>
    </div>
  </div>
</div>

} @else {
<div
  class="container"
  [style]="{
    border: '2px solid #719eb6',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
  id="uncollapsedProgram"
  [ngClass]="{ 'program-selected': isProgramSelected() }"
>
  <div
    class="row h-4rem align-items-center justify-content-between"
    id="programCellHeader"
  >
    <div class="col-3 d-flex align-items-center">
      <button
        type="button"
        class="btn btn-primary position-relative program-name"
        (click)="toggleCollapsed()"
        [id]="'toggleCollapseButton-' + program?.ProgramName"
      >
        {{ program?.ProgramName }}
        <i
          class="pi pi-circle-fill ms-2"
          style="
            font-size: 1rem;
            color: #9382ad;
            border: 1px solid white;
            border-radius: 50%;
          "
          *ngIf="programAlerts().length > 0"
        ></i>
      </button>
    </div>

    @if (program?.IsDeleted) {
    <div class="col-1">
      <p-tag id="deleted-tag" severity="danger" value="Deleted" class="ms-2" />
    </div>
    } @if (program?.IsArchived) {
    <div class="col-1">
      <p-tag
        id="archived-tag"
        severity="warning"
        value="Archived"
        class="ms-2"
      />
    </div>
    }

    <div class="col-3 col-md-3 mx-3 mt-2 mt-md-0">
      <span class="fs-8 fw-bolder" style="color: #719eb6">
        Included Playlists:
      </span>
      <span class="fs-8" style="color: #719eb6">
        {{ program!.ID != null ? playlistsToDisplay(program!.ID) : "None" }}
      </span>
    </div>
    <div class="col-3 col-md-3 mx-3 mt-2 mt-md-0">
      <span class="fs-8 fw-bolder" style="color: #719eb6"> Skill Areas: </span>
      <span class="fs-8" style="color: #719eb6">
        {{ skillAreasToDisplay }}
      </span>
    </div>

    <div class="col-1">
      <i
        class="pi pi-circle-fill me-2"
        style="
          font-size: 1rem;
          border: 2px solid #e1e8fb;
          border-radius: 50%;
          cursor: pointer;
        "
        [style.color]="getCircleColor()"
        [style.border-radius]="'50%'"
        [title]="getCircleTooltip()"
      ></i>
      <i
        class="pi pi-arrow-up pointer"
        (click)="toggleCollapsed()"
        style="font-size: 1rem; color: #719eb6"
      ></i>
    </div>
  </div>

  @if (programAlerts().length > 0) {
  <div class="row mt-2">
    <div class="col-12">
      <div
        class="alert"
        role="alert"
        style="background-color: #9382ad; color: white"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div class="">
            <i class="pi pi-exclamation-triangle me-2"></i>
            <span class="fw-bold">{{ programAlerts()[0].sender }}:</span>
            <span class="text-truncate w-80 text-wrap" style="color: white">
              {{ programAlerts()[0].message }}
            </span>
          </div>
          <span
            class="fw-bold"
            style="color: white; cursor: pointer"
            (click)="dismissAlertButtonClicked(programAlerts()[0])"
          >
            Dismiss
          </span>
        </div>
      </div>
    </div>
  </div>
  }

  <div id="programCellDetails">
    @if (program?.LastChangedDate) {
    <div class="row">
      <div class="col-12">
        <div
          class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
        >
          <span class="fw-bold" style="color: #719eb6">Last Changed Date:</span>
          <span class="text-truncate" style="color: #719eb6">
            {{ program?.LastChangedDate | date }}
          </span>
        </div>
      </div>
    </div>
    }

    <div class="row">
      <div class="col-12">
        <div class="mx-3 my-2">
          <div class="d-flex align-items-start">
            <span class="fw-bold me-2" style="color: #719eb6">Goal(s):</span>
            <span
              class="flex-grow-1"
              style="
                color: #719eb6;
                white-space: pre-wrap;
                word-wrap: break-word;
              "
            >
              {{ getProgramGoal() || "No goal(s) provided" }}
            </span>
          </div>
        </div>
      </div>
    </div>

    @if (getBspObjective(); as bspObjective) {
    <div class="row">
      <div class="col-12">
        <div class="mx-3 my-2">
          <div class="d-flex align-items-start">
            <span class="fw-bold me-2 text-nowrap" style="color: #719eb6"
              >BSP Objective:</span
            >
            <span
              class="flex-grow-1"
              style="
                color: #719eb6;
                white-space: pre-wrap;
                word-wrap: break-word;
              "
            >
              {{ bspObjective.SkillArea }} - {{ bspObjective.Program
              }}@if (bspObjective.GoalStatus) {&nbsp;({{
                bspObjective.GoalStatus
              }})}
            </span>
          </div>
          @if (!bspObjective.Goal && bspObjective.PreviousGoal) {
          <div class="d-flex align-items-start mt-1">
            <span class="fw-bold me-2 text-nowrap" style="color: #719eb6"
              >Previous Objective:</span
            >
            <span
              class="flex-grow-1"
              style="
                color: #719eb6;
                white-space: pre-wrap;
                word-wrap: break-word;
              "
            >
              {{ bspObjective.PreviousGoal }}
            </span>
          </div>
          }
        </div>
      </div>
    </div>
    }

    <div class="row">
      <div class="col-12">
        <div
          class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
        >
          <span class="fw-bold" style="color: #719eb6">Status:</span>
          <span class="text-truncate" style="color: #719eb6">
            {{ getCircleTooltip() }}
          </span>
        </div>
      </div>
    </div>

    <div class="row" id="programTargetsList">
      <div class="col-12">
        <div class="row">
          @for (target of TargetsToShow; track target.ID) {
          <app-target
            [patientID]="patientID()"
            [target]="target"
            [isExpanded]="
              targetExpandedStatus[target.ID!] ||
              programTargetsExpandedStatus[target.ID!]
            "
            (isExpandedChange)="onTargetExpandedChange(target.ID!, $event)"
          />
          } @empty {
          <p>There are no targets for this program yet.</p>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Full width notes section -->
  <div class="col-12 mt-3">
    <div class="mx-3">
      <div class="d-flex justify-content-between align-items-center">
        <span class="fw-bold" style="color: #719eb6"
          >Program Notes:
          <i style="font-size: 12px; opacity: 0.5">{{
            lastModifiedByText() +
              (program?.NotesLastModifiedDate != null
                ? (program?.NotesLastModifiedDate | date : "MM/dd/yyyy hh:mm a")
                : "")
          }}</i></span
        >
        <div class="d-flex gap-2">
          <button
            *ngIf="!isEditingProgramNotes"
            pButton
            class="p-button-outlined side-menu-button2"
            icon="pi pi-pencil"
            (click)="startEditingProgramNotes()"
          >
            Edit
          </button>
          <div *ngIf="isEditingProgramNotes" class="d-flex gap-2">
            <button
              pButton
              class="p-button-outlined side-menu-button2"
              icon="pi pi-check"
              (click)="saveProgramNotes()"
            >
              Save
            </button>
            <button
              pButton
              class="p-button-outlined switch-mode-button"
              icon="pi pi-times"
              (click)="cancelEditingProgramNotes()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <textarea
        pTextarea
        [disabled]="!isEditingProgramNotes"
        [(ngModel)]="program!.ProgramNotes"
        rows="3"
        style="width: 100%; margin-top: 0.5rem"
      ></textarea>
    </div>
  </div>

  <div class="row" id="programCellButtons">
    <div class="col-12">
      <div
        class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
      >
        <button
          (click)="editProgram()"
          [id]="'editProgramButton-' + program?.ProgramName"
          class="side-menu-button2 flex-grow-1 mx-2"
          [disabled]="program?.IsDeleted"
          [style.opacity]="program?.IsDeleted ? '0.5' : '1'"
          [style.cursor]="program?.IsDeleted ? 'not-allowed' : 'pointer'"
        >
          Edit
        </button>
        <button
          (click)="showChangeLog()"
          [id]="'changeLogButton-' + program?.ProgramName"
          class="side-menu-button2 flex-grow-1 mx-2"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        >
          <i class="pi pi-history me-1"></i>
          Change Log
        </button>
        <button
          (click)="goToStaffManagementReport()"
          class="side-menu-button2 flex-grow-1 mx-2"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        >
          Staff Report
        </button>
        @if (!program?.IsDeleted) {

        <button
          (click)="deleteProgram()"
          [id]="'deleteProgramButton-' + program?.ProgramName"
          class="switch-mode-button flex-grow-1 mx-2"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        >
          Delete
        </button>
        } @else{
        <button
          (click)="restoreProgram()"
          [id]="'restoreProgramButton-' + program?.ProgramName"
          class="side-menu-button2 flex-grow-1 mx-2"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        >
          Restore
        </button>
        }
      </div>
    </div>
  </div>

  <app-change-log-modal
    #changeLogModal
    [entityID]="program?.ID ?? null"
    [entityType]="entityTypeProgram"
    [entityName]="program?.ProgramName ?? ''"
  ></app-change-log-modal>
</div>
}
